import React from "react";
import { ArrowLeft } from "lucide-react";
import { Logo } from "./Logo";

export const GREEN = "#1F3A30";
export const GOLD = "#C9A45C";
export const RUST = "#B5602E";
export const IVORY = "#F5F0E6";
export const ART_MOON = "https://static.prod-images.emergentagent.com/jobs/a04d81c8-8ddd-47c0-93b4-fd8d9e3680be/images/6314707fc1e04b152674aaffd3c59f3b406622ea5ab8ccebeb6a534f84573cbe.jpeg";
export const ART_LEAVES = "/art-leaves.jpg";
export const ART_ZODIAC = "/art-zodiac.jpg";
export const ART_LOTUS = "/art-lotus.jpg";
export const ART_ARCH = "https://static.prod-images.emergentagent.com/jobs/a04d81c8-8ddd-47c0-93b4-fd8d9e3680be/images/cf2020cd1e55eefd6cda65419189b365487a3fec250ebc1262e625bf1e4a44bb.jpeg";

export const ProgressBar = ({ value }) => (
    <div className="h-1 w-full rounded-full overflow-hidden" style={{ background: "#D9D3C4" }}>
        <div className="h-full rounded-full transition-all duration-500" style={{ width: `${Math.min(100, Math.max(0, value))}%`, background: GREEN }} />
    </div>
);

export const StepFrame = ({ onBack, right, stepLabel, progress, title, subtitle, children, footer, art, artDark, quote }) => (
    <div className="min-h-[calc(100vh-4rem)] lg:grid" style={{ gridTemplateColumns: art ? "minmax(0,1fr) 320px" : "1fr" }}>
        <div className="max-w-3xl mx-auto w-full px-5 sm:px-10 py-6 sm:py-8 flex flex-col">
            <div className="flex items-center justify-between">
                {onBack ? (
                    <button data-testid="step-back-icon" onClick={onBack} className="p-1 -ml-1 hover:opacity-70" style={{ color: GREEN }}><ArrowLeft size={20} strokeWidth={1.6} /></button>
                ) : <span className="w-6" />}
                <div className="text-xl"><Logo /></div>
                <div className="text-xs min-w-[1.5rem] text-right" style={{ color: `${GREEN}B3` }}>{right}</div>
            </div>
            <div className="mt-7">
                <p className="text-xs mb-2" style={{ color: `${GREEN}CC` }}>{stepLabel}</p>
                <ProgressBar value={progress} />
            </div>
            <h1 className="mt-8 font-serif text-3xl sm:text-4xl lg:text-[2.6rem] leading-tight" style={{ color: GREEN }}>{title}</h1>
            {subtitle && <p className="mt-2 text-sm sm:text-base max-w-xl" style={{ color: "#4E5A54" }}>{subtitle}</p>}
            <div className="mt-7 flex-1">{children}</div>
            <div className="mt-10 flex items-end justify-between gap-4">
                {quote ? <p className="font-serif italic text-lg sm:text-xl max-w-xs leading-snug" style={{ color: "#5B665F" }}>{quote}</p> : <span />}
                <div className="flex items-center gap-3 shrink-0">{footer}</div>
            </div>
        </div>
        {art && (
            <aside className="hidden lg:block relative overflow-hidden" aria-hidden="true">
                <img src={art} alt="" className={`absolute inset-0 w-full h-full object-cover ${artDark ? "" : "object-right"}`} />
                {artDark && <div className="absolute inset-0" style={{ background: `linear-gradient(90deg, ${IVORY} 0%, ${IVORY}00 45%)` }} />}
            </aside>
        )}
    </div>
);

export const PrimaryBtn = ({ children, className = "", ...p }) => (
    <button {...p} className={`inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold transition hover:brightness-110 disabled:opacity-50 ${className}`}
        style={{ background: GREEN, color: IVORY }}>{children}</button>
);

export const GhostBtn = ({ children, className = "", ...p }) => (
    <button {...p} className={`inline-flex items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-medium transition hover:bg-black/5 disabled:opacity-40 ${className}`}
        style={{ border: `1px solid ${GREEN}26`, color: GREEN, background: "#FBF8F1" }}>{children}</button>
);

export const Field = ({ label, hint, ...p }) => (
    <label className="block">
        <span className="text-xs font-medium" style={{ color: "#4E5A54" }}>{label}</span>
        <input {...p} className="mt-1.5 w-full rounded-lg px-4 py-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#1F3A30]/30"
            style={{ border: `1px solid ${GREEN}26` }} />
        {hint && <span className="block mt-1 text-[11px]" style={{ color: "#6B766F" }}>{hint}</span>}
    </label>
);
